<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/users/table">用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="手机号"
                          prop="cellphone">
              <el-input v-model="form.cellphone"
                        :disabled="this.form.userid > 0"></el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input v-model="form.password"
                        type="password"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
              <el-input v-model="form.realname"></el-input>
            </el-form-item>
            <el-form-item label="显示姓名">
              <el-input v-model="form.nickname"></el-input>
            </el-form-item>
            <el-form-item label="用户类型">
              <el-select v-model="form.type"
                         :disabled="form.type === 90"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="item in options.type"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                           :disabled="item.value === 90">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所在地区">
              <el-col :span="6">
                <el-select v-model="form.provinceid"
                           placeholder="请选择"
                           class="width-max"
                           @change="onSearchCityChildren(form.provinceid)">
                  <el-option v-for="item in options.provinces"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="6"
                      :offset="1">

                <el-select v-model="form.cityid"
                           placeholder="请选择"
                           class="width-max"
                           @change="onSearchAreaChildren(form.cityid)">
                  <el-option v-for="item in userOptions.cities"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="6"
                      :offset="1">

                <el-select v-model="form.areaid"
                           placeholder="请选择"
                           class="width-max">
                  <el-option v-for="item in userOptions.areas"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-col>

            </el-form-item>
            <el-form-item label="注册超市">
              <el-select v-model="form.marketid"
                         filterable
                         remote
                         reserve-keyword
                         placeholder="请输入关键词"
                         :remote-method="remoteMethodMarket"
                         :loading="loading">
                <el-option v-for="item in userOptions.markets"
                           :key="item.id"
                           :label="item.marketname"
                           :value="parseInt(item.id)">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input v-model="form.idnum"></el-input>
            </el-form-item>
            <el-form-item label="身份验证">
              <el-select v-model="form.idnumverified"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="(item) in options.idnumverified"
                           :key="item.value"
                           :disabled="item.value === 3"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="银行卡号">
              <el-input v-model="form.creditcardno"></el-input>
            </el-form-item>
            <el-form-item label="银行卡验证">
              <el-select v-model="form.bankcardverified"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="item in options.bankcardverified"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属银行">
              <el-input v-model="form.bankname"></el-input>
            </el-form-item>
            <el-form-item v-if="this.form.userid > 0"
                          label="开户行城市">
              <el-input v-model="form.bankcity"></el-input>
            </el-form-item>
            <el-form-item label="支付宝账号">
              <el-input v-model="form.zfb_account"></el-input>
            </el-form-item>
            <el-form-item label="支付宝验证">
              <el-select v-model="form.zfb_accountverified"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="item in options.zfb_accountverified"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="微信账号">
              <el-input v-model="form.wx_account" />
            </el-form-item>
            <el-form-item label="禁止提现">
              <el-select v-model="form.is_forbidden_withdraw"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="item in options.is_forbidden_withdraw"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户是否可信">
              <el-select v-model="form.believable"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="item in options.believable"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户状态">
              <el-select v-model="form.status"
                         placeholder="请选择"
                         class="width-max"
                         :disabled="true">
                <el-option v-for="item in options.status"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="推荐人手机">
              <el-input v-model="form.referrer"></el-input>
            </el-form-item>
            <el-form-item label="推荐码">
              <el-input v-model="form.referrercode"></el-input>
            </el-form-item>
            <el-form-item label="身份证照片">
              <el-upload class="avatar-uploader"
                         action=""
                         :auto-upload="false"
                         :show-file-list="false"
                         :on-change="query => onChangeFile(query,1)">
                <img v-if="form.idcardphotopath"
                     :src="form.idcardphotopath"
                     class="avatar"
                     style="width:100px;height:100px">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="身份证背面照片">
              <el-upload class="avatar-uploader"
                         action=""
                         :auto-upload="false"
                         :show-file-list="false"
                         :on-change="query => onChangeFile(query,4)">
                <img v-if="form.idcardphoto_back"
                     :src="form.idcardphoto_back"
                     class="avatar"
                     style="width:100px;height:100px">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="人脸验证照片"
                          prop="idnum_verify_photo">
              <el-upload class="avatar-uploader"
                         action=""
                         :auto-upload="false"
                         :show-file-list="false"
                         :on-change="query => onChangeFile(query,6)">
                <img v-if="form.idnum_verify_photo"
                     :src="form.idnum_verify_photo"
                     class="avatar"
                     style="width:100px;height:100px">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="验证照片">
              <el-upload class="avatar-uploader"
                         action=""
                         :auto-upload="false"
                         :show-file-list="false"
                         :on-change="query => onChangeFile(query,2)">
                <img v-if="form.photopath"
                     :src="form.photopath"
                     class="avatar"
                     style="width:100px;height:100px">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="用户头像">
              <el-upload class="avatar-uploader"
                         action=""
                         :auto-upload="false"
                         :show-file-list="false"
                         :on-change="query => onChangeFile(query,3)">
                <img v-if="form.avatarpath"
                     :src="form.avatarpath"
                     class="avatar"
                     style="width:100px;height:100px">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="工作证（后台上传）"
                          v-if="$route.meta.type !== 'edit_user'"
                          prop="workcard_photo">
              <el-upload action=""
                         :auto-upload="false"
                         :show-file-list="false"
                         :on-change="query => onChangeFile(query, 5)">
                <el-button type="primary" size="small">上传工作证</el-button>
              </el-upload>
              <div id="photoContainer"
                   v-if="form.workcard_photo.length > 0">
                <img
                  v-for="(photo, index) in form.workcard_photo"
                  v-contextmenu:contextmenu
                  :key="index"
                  :src="photo"
                  @click="onViewWorkCardPhotos(index)"
                  class="avatar"
                  style="width:80px;height:80px;padding: 10px;display:inline-block;cursor: zoom-in">
              </div>
            </el-form-item>
            <el-form-item label="身份证地址">
              <el-input v-model="form.idcard_address"></el-input>
            </el-form-item>
            <el-form-item label="身份证过期时间">
              <el-input v-model="form.idcard_expired_date"
                        placeholder="格式:年月日,例如 20250528 或 长期"></el-input>
            </el-form-item>
            <el-form-item v-if="this.form.userid > 0" label="原有标签">
              <div v-if="form.tag_existing_display && form.tag_existing_display.length > 0" class="tag-container">
                <el-tag v-for="item in form.tag_existing_display"
                        :key="item.id"
                        type="success"
                        class="tag-item">
                  {{ item.tagname }}
                </el-tag>
              </div>
              <span v-else class="no-tags-text">暂无标签</span>
            </el-form-item>
            <el-form-item label="新增标签">
              <remote-select v-model="form.tag_add"
                             placeholder="请输入标签名称搜索添加标签"
                             :queryRequest="(params) => getUserTagTable(Object.assign({is_group: 0}, params))"
                             :findRequest="getUserTagDetail"
                             clearable
                             multiple
                             keyword-key="keyword"
                             value-key="id"
                             label-key="tagname"
                             id-key="id">
              </remote-select>
            </el-form-item>
            <el-form-item v-if="this.form.userid > 0" label="删除标签">
              <el-select v-model="form.tag_delete"
                         multiple
                         filterable
                         remote
                         reserve-keyword
                         placeholder="请输入关键词删除标签"
                         :remote-method="remoteMethodTagForDelete"
                         :loading="loading"
                         @focus="onDeleteTagFocus">
                <el-option v-for="item in userOptions.tagsForDelete"
                           :key="item.id"
                           :label="item.tagname"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户能力组">
              <el-select v-model="form.personal_ability"
                         multiple
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in options.abilities"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="超级零工属性">
              <el-select v-model="form.attributes"
                         multiple
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in options.attributes"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="行业" v-if="$route.meta.type !== 'edit_user'" prop="business_type">
              <el-select v-model="form.business_type"
                         @change="form.work_type=null"
                         class="width-max"
                         placeholder="请选择">
                <el-option v-for="item in options.business_type"
                           :disabled="item.disabled"
                           :key="item.id"
                           :label="item.title"
                           :value="item.id">
                  <span style="float: left">{{ item.title }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.subTitle }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工种" v-if="$route.meta.type !== 'edit_user'" prop="work_type">
              <el-select v-model="form.work_type"
                         class="width-max"
                         placeholder="请先选择行业">
                <el-option v-for="item in filtered_work_type"
                           :disabled="item.disabled"
                           :key="item.id"
                           :label="item.title"
                           :value="item.id">
                  <span style="float: left">{{ item.title }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="厂家" v-if="$route.meta.type !== 'edit_user'" prop="belongto">
              <el-input v-model="form.belongto" class="width-max"></el-input>
            </el-form-item>
          </div>

        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <v-contextmenu ref="contextmenu" @contextmenu="onWorkCardContextMenu">
      <v-contextmenu-item @click="onDeleteWorkCardPhoto">删除</v-contextmenu-item>
    </v-contextmenu>

  </div>
</template>

<script>
import { formRules } from '../users.rules.js'
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'

Vue.use(contentmenu)

export default {
  components: {},
  data () {
    return {
      formRules,
      form: {
        userid: this.$route.params.id,
        cellphone: null,
        password: null,
        realname: null,
        nickname: null,
        type: null,
        provinceid: null,
        cityid: null,
        areaid: null,
        marketid: null,
        idnum: null,
        idnumverified: null,
        creditcardno: null,
        bankcardverified: null,
        zfb_account: null,
        zfb_accountverified: null,
        wx_account: null,
        is_forbidden_withdraw: 0,
        believable: null,
        status: 1,
        referrer: null,
        referrercode: null,
        idcardphotopath: null,
        idcardphoto_back: null,
        photopath: null,
        avatarpath: null,
        personal_ability: [],
        attributes: [],
        bankname: null,
        bankcity: null,
        belongto: null,
        work_type: null,
        business_type: null,
        idnum_verify_photo: null,
        workcard_photo: [],
        idcard_address: null,
        idcard_expired_date: null,
        tag_existing: [],
        tag_existing_display: [],
        tag_add: [],
        tag_delete: [],
      },
      loading: false,
      userOptions: {
        markets: [],
        tags: [],
        tagsForDelete: [],
        cities: [],
        areas: [],
      },
      idnumverified: null,
      view: null,
      currentWorkCardContextMenuIndex: null,
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.users.options,
    }),
    filtered_work_type () {
      return this.options.business_work_type.filter(it => {
        return it.businessTypeId + '' === this.form.business_type + ''
      })
    }
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...Vuex.mapMutations(['SET_USER_OPTIONS']),
    ...request.map(['getUserTagTable', 'getUserTagDetail']),

    onLoad () {
      if (this.$route.params.id) {
        this.setForm()
      } else {
        request('getUserDetailOption', 0).then(({data}) => {
          this.SET_USER_OPTIONS(data)
        })
        this.form.idnumverified = 0
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    setForm () {
      request.all.page([
        request('getUser', this.form.userid),
        request('getUserDetailOption', this.form.userid),
      ]).then(([userDetail, detailOptions]) => {
        (({data}) => {
          filter.setLoop(this.form, data)
          if (data.personal_ability.length > 0) {
            this.form.personal_ability = this.form.personal_ability.split(',')
            for (let i = 0; i < this.form.personal_ability.length; i++) {
              this.form.personal_ability[i] = parseInt(this.form.personal_ability[i])
            }
          } else {
            this.form.personal_ability = []
          }
          if (data.superworker_attribute.length > 0) {
            this.form.attributes = data.superworker_attribute.split(',')
            for (let i = 0; i < this.form.attributes.length; i++) {
              this.form.attributes[i] = parseInt(this.form.attributes[i])
            }
          }
          // 处理标签：原有标签、新增标签、删除标签
          if (data.tag) {
            const existingTagIds = data.tag.split(',').filter(id => id !== '').map(id => parseInt(id))
            this.form.tag_existing = existingTagIds
            // 获取标签详情用于显示 - 通过 getUserTagTable 批量获取标签详情
            if (existingTagIds.length > 0) {
              // 使用 getUserTagTable 通过 tag_id 参数获取标签列表（tag_id 需要是数组）
              request.common('getUserTagTable', {tag_id: existingTagIds}).then(({data}) => {
                // 解析返回的数据结构：data 是 {total, per_page, current_page, data: [...]}
                // 标签数组在 data.data 中
                const tags = (data && data.data && Array.isArray(data.data)) ? data.data : []

                // 确保标签ID是数字类型，用于匹配
                const normalizedTags = tags.map(tag => ({
                  id: parseInt(tag.id),
                  tagname: tag.tagname || tag.name || ('标签' + tag.id)
                }))

                // 过滤出用户已有的标签，并按ID顺序排序
                this.form.tag_existing_display = existingTagIds.map(id => {
                  const tag = normalizedTags.find(t => t.id === id)
                  return tag || {id: id, tagname: '标签' + id}
                }).filter(tag => tag)
                // 预设删除标签的下拉选项为用户已有的标签
                this.userOptions.tagsForDelete = this.form.tag_existing_display
              }).catch((error) => {
                // 如果获取失败，至少显示标签ID
                console.error('获取标签详情失败:', error)
                this.form.tag_existing_display = existingTagIds.map(id => ({id: id, tagname: '标签' + id}))
                // 即使获取失败，也预设删除标签的下拉选项
                this.userOptions.tagsForDelete = this.form.tag_existing_display
              })
            } else {
              this.form.tag_existing_display = []
              this.userOptions.tagsForDelete = []
            }
          } else {
            this.form.tag_existing = []
            this.form.tag_existing_display = []
          }
          this.form.tag_add = []
          this.form.tag_delete = []
          if (!data.work_type) {
            this.form.work_type = ''
          }
          this.idnumverified = this.form.idnumverified
        })(userDetail)
        ;(({data}) => {
          this.SET_USER_OPTIONS(data)
          filter.setLoop(this.userOptions, data)
        })(detailOptions)
      })
    },
    onSubmit () {
      if (this.form.idcardphotopath && !this.form.idcard_address) {
        this.$message.error('身份证照片更新后，请手动填写身份证地址')
        return
      }
      if (this.form.idcardphoto_back) {
        if (!this.form.idcard_expired_date) {
          this.$message.error('身份证背面照片更新后,请手动填写身份证过期时间')
          return
        }
        if (this.form.idcard_expired_date !== '长期') {
          if (!/^\d{8}$/.test(this.form.idcard_expired_date)) {
            this.$message.error('身份证过期时间格式错误，请输入8位日期(如20250508)或"长期"')
            return
          }
          const y = parseInt(this.form.idcard_expired_date.substring(0, 4))
          const m = parseInt(this.form.idcard_expired_date.substring(4, 6))
          const d = parseInt(this.form.idcard_expired_date.substring(6, 8))
          const date = new Date(y, m - 1, d)
          if (date.getFullYear() !== y || (date.getMonth() + 1) !== m || date.getDate() !== d) {
            this.$message.error('身份证过期时间日期不合法，请输入正确的过期日期')
            return
          }
        }
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.userid ? this.update(this.form.userid) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    update (id) {
      // 构建提交数据，只提交 tag_add 和 tag_delete，不提交 tag_existing
      const submitData = {
        ...this.form,
        tag_add: this.form.tag_add || [],
        tag_delete: this.form.tag_delete || [],
      }
      // 移除不需要的字段
      delete submitData.tag_existing
      delete submitData.tag_existing_display
      delete submitData.tag
      request.common('updateUser', submitData).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/users/table/'})
        })
      })
    },
    create () {
      request.common('createUser', this.form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/users/table/'})
        })
      })
    },
    remoteMethodMarket (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          request.alert('getUserMarketName', {query: query}).then(({data}) => {
            this.userOptions.markets = data
            this.loading = false
          })
        }, 500)
      }
    },
    // 新增标签的搜索在 remote-select 组件内部通过 getUserTagTable / getUserTagDetail 完成
    onDeleteTagFocus () {
      // 当删除标签下拉框获得焦点时，如果没有选项，则加载用户已有的标签
      if (!this.userOptions.tagsForDelete || this.userOptions.tagsForDelete.length === 0) {
        this.userOptions.tagsForDelete = this.form.tag_existing_display || []
      }
    },
    remoteMethodTagForDelete (query) {
      const existingTagIds = this.form.tag_existing || []
      if (existingTagIds.length === 0) {
        this.userOptions.tagsForDelete = []
        return
      }

      this.loading = true
      setTimeout(() => {
        if (query && query.trim() !== '') {
          // 如果有搜索关键词，搜索标签并过滤出用户已有的标签
          request.alert('getUserTagName', {query: query, is_group: 0}).then(({data}) => {
            // 只显示用户当前已有的标签
            this.userOptions.tagsForDelete = (data || []).filter(tag => existingTagIds.includes(tag.id))
            this.loading = false
          }).catch(() => {
            // 如果搜索失败，使用预设的标签列表
            this.userOptions.tagsForDelete = this.form.tag_existing_display || []
            this.loading = false
          })
        } else {
          // 如果没有搜索关键词，显示所有用户已有的标签（预设的标签列表）
          this.userOptions.tagsForDelete = this.form.tag_existing_display || []
          this.loading = false
        }
      }, 500)
    },
    onChangeFile (file, type) {
      let isExcel = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
      let isLt2M = file.raw.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadFile(file.raw, type)
    },
    onUploadFile (file, type) {
      let formData = new FormData()
      formData.append('pic', file)
      return request.alert('uploadUserImg', formData).then(({data}) => {
        if (type === 1) {
          this.form.idcardphotopath = data
          this.form.idcard_address = null
        } else if (type === 2) {
          this.form.photopath = data
        } else if (type === 3) {
          this.form.avatarpath = data
        } else if (type === 4) {
          this.form.idcardphoto_back = data
          this.form.idcard_expired_date = null
        } else if (type === 5) {
          this.form.workcard_photo.push(data)
        } else if (type === 6) {
          this.form.idnum_verify_photo = data
        }
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
    onSearchCityChildren (parentId) {
      let self = this
      request.alert('getCityList', parentId).then(({data}) => {
        this.userOptions.cities = data
        self.form.cityid = ''
        self.form.areaid = ''
      })
    },
    onSearchAreaChildren (parentId) {
      let self = this
      request.alert('getAreaList', parentId).then(({data}) => {
        this.userOptions.areas = data
        self.form.areaid = ''
      })
    },
    forcePass () {
      let detail = {orderid: this.orderid}
      request.common('orderVerifyFaceEnforce', detail).then((res) => {
        this.$message('手动通过成功！')
      })
    },
    onViewImage (event) {
      if (!this.views) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
    onViewWorkCardPhotos (index) {
      if (this.viewer) {
        this.viewer.destroy()
      }
      this.viewer = new Viewer(document.getElementById('photoContainer'))
      this.viewer.view(index)
    },
    onDeleteWorkCardPhoto () {
      this.form.workcard_photo.splice(this.currentWorkCardContextMenuIndex, 1)
    },
    onWorkCardContextMenu (vm) {
      this.currentWorkCardContextMenuIndex = vm.key
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html

// 原有标签样式
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-item {
  margin: 0;
  border-radius: 16px;
}

.no-tags-text {
  color: #909399;
  font-size: 14px;
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/users/pages/UsersForm.vue